export enum AJUSTES_DEFAULT {
  DISPOSITIVO = 'Dev_Test',
  EQUIPO_COMPUTO = 1,

  WMS_API_URL_LOCALHOST = 'http://localhost:51635/api/',


  WMS_API_URL = 'https://wms-api.grupo-logistics.com/prod/api/',
  WMS_API_URL_TEST = 'https://wms-api-test.grupo-logistics.com/test/api/',
  WMS_API_URL_QA = 'https://wms-api-qa.grupo-logistics.com/qa/api/',

  WMS_API_OPERACION_URL = 'https://wms-api.grupo-logistics.com/operacion/api/',
  // WMS_API_OPERACION_URL_TEST = 'https://wms-api-test.grupo-logistics.com/test/api/',

  GALO_API_URL = 'https://ws.grupo-logistics.com/GALOApi/api/',
  GALO_API_URL_TEST = 'https://ws-test.grupo-logistics.com/GALOApi/api/',


  WMS_API_REPORTES_URL = 'https://wms-api.grupo-logistics.com/reports/api/',
  // WMS_API_REPORTES_URL_TEST = 'https://wms-api-test.grupo-logistics.com/test/api/',





  // WMS_APP_URL_ETIQUETAS = 'https://wms-api-test.grupo-logistics.com/ProdLabels/',

  DIAS_VALIDEZ_TOKEN = 15,
  API_KEY = '2PTm8E+QVvzidJPSMxL0c49oSmY/CvVzFojvgW8/662N3Fvyhvepz+l0JDX5l9esDevtl1F41aTHJ0LzxUL8ag==',
  REALM = 'kLlhGcwPdwZ8JcevgIlJ/FUXUUNIMWrK',
  IP = '10.22.3.12',
  PUERTO_IP = 9100,
  PORT_NAME_BT = 'COM9',
  BAUD_RATE_BT = 19200,
  IMPRESORA_BT = '',
  BROADCAST_SCANER_DATA_INTENT = 'com.honeywell.scantointent.intent.action.BARCODE',
  BROADCAST_SCANER_DATA_ID = 'data',
  // ADMIN_PASS = 'SER.123',

  PLATFORM_COLOR_OTRO = 'medium',
  PLATFORM_COLOR_TEST = 'warning',
  PLATFORM_COLOR_QA = 'danger',

  TEMA_SONIDOS = 'default',
  MENSAJE_ERROR = 'MensajeError.mp3',
  MENSAJE_CORRECTO = 'MensajeCorrecto.mp3',
  MENSAJE_ERROR_CONECCION = 'MensajeErrorConeccion.mp3',
  MENSAJE_CORRECTO_CONECCION = 'MensajeCorrectoConeccion.mp3',
  MENSAJE_COMPLETADO = 'MensajeCompletado.mp3',
  MENSAJE_ATENCION = 'MensajeAtencion.mp3'
}

export class SettingsApp {
  strDispositivo: string;
  IdEquipoComputo: number;

  strHeaderColor: string;

  mostrarTutorial: boolean;
  wmsApiUrl: string;
  wmsApiOperacionUrl: string;
  wmsApiReportesUrl: string;
  galoApiUrl: string;
  wmsAppUrlEtiquetas: string;
  diasValidezToken: number;
  apiKey: string;
  realm: string;

  blnPrintWifi: boolean;
  strIP: string;
  intPuerto: number;
  strBTImpresora: string;

  blnPrintBluetooth: boolean;
  strPortName: string;
  intBaudRate: number;

  blnZebraBrowserPrint: boolean;
  strUidZebraBrowserPrint: string;


  blnPuedeUsarTecladoEnEscaneo: boolean;
  strBroadcastScanerDataIntent: string;
  strBroadcastScanerDataId: string;

  blnEsHadHeld: boolean;

  strAdminPass: string;

  strTemaSonidos: string;

  strMensajeError: string;
  strMensajeCorrecto: string;
  strMensajeErrorConeccion: string;
  strMensajeCorrectoConeccion: string;
  strMensajeCompletado: string;
  strMensajeAtencion: string;

  blnDarkMode: boolean;

  constructor(mostrarTutorial: boolean, EsHadHeld: boolean) {



    this.strDispositivo = AJUSTES_DEFAULT.DISPOSITIVO;
    this.IdEquipoComputo = AJUSTES_DEFAULT.EQUIPO_COMPUTO;
    this.mostrarTutorial = mostrarTutorial;


    switch (window.location.hostname) {
      case 'wms.grupo-logistics.com':
        this.wmsApiUrl = AJUSTES_DEFAULT.WMS_API_URL;
        this.wmsApiOperacionUrl = AJUSTES_DEFAULT.WMS_API_OPERACION_URL;
        this.wmsApiReportesUrl = AJUSTES_DEFAULT.WMS_API_REPORTES_URL;
        this.galoApiUrl = AJUSTES_DEFAULT.GALO_API_URL;
        this.strHeaderColor = undefined;
        break;
      case 'wms-test.grupo-logistics.com':
        this.wmsApiUrl = AJUSTES_DEFAULT.WMS_API_URL_TEST;
        this.wmsApiOperacionUrl = AJUSTES_DEFAULT.WMS_API_URL_TEST;
        this.wmsApiReportesUrl = AJUSTES_DEFAULT.WMS_API_URL_TEST;
        this.galoApiUrl = AJUSTES_DEFAULT.GALO_API_URL_TEST;
        this.strHeaderColor = AJUSTES_DEFAULT.PLATFORM_COLOR_TEST;
        break;
      case 'wms-qa.grupo-logistics.com':
        this.wmsApiUrl = AJUSTES_DEFAULT.WMS_API_URL_QA;
        this.wmsApiOperacionUrl = AJUSTES_DEFAULT.WMS_API_URL_QA;
        this.wmsApiReportesUrl = AJUSTES_DEFAULT.WMS_API_URL_QA;
        this.galoApiUrl = AJUSTES_DEFAULT.GALO_API_URL_TEST;
        this.strHeaderColor = AJUSTES_DEFAULT.PLATFORM_COLOR_QA;
        break;
      case 'localhost':

        if (EsHadHeld) {
          this.wmsApiUrl = AJUSTES_DEFAULT.WMS_API_URL;
          this.wmsApiOperacionUrl = AJUSTES_DEFAULT.WMS_API_OPERACION_URL;
          this.wmsApiReportesUrl = AJUSTES_DEFAULT.WMS_API_REPORTES_URL;
          this.galoApiUrl = AJUSTES_DEFAULT.GALO_API_URL;
          this.strHeaderColor = undefined;
        } else {
          this.wmsApiUrl = AJUSTES_DEFAULT.WMS_API_URL_LOCALHOST;
          this.wmsApiOperacionUrl = AJUSTES_DEFAULT.WMS_API_URL_LOCALHOST;
          this.wmsApiReportesUrl = AJUSTES_DEFAULT.WMS_API_URL_LOCALHOST;
          this.galoApiUrl = AJUSTES_DEFAULT.GALO_API_URL_TEST;
          this.strHeaderColor = AJUSTES_DEFAULT.PLATFORM_COLOR_TEST;
        }
        break;
      default:
        this.wmsApiUrl = AJUSTES_DEFAULT.WMS_API_URL_TEST;
        this.wmsApiOperacionUrl = AJUSTES_DEFAULT.WMS_API_URL_TEST;
        this.wmsApiReportesUrl = AJUSTES_DEFAULT.WMS_API_URL_TEST;
        this.galoApiUrl = AJUSTES_DEFAULT.GALO_API_URL_TEST;
        break;
    }

    // console.log(this.wmsApiUrl, this.wmsApiOperacionUrl, this.wmsApiReportesUrl, this.galoApiUrl);


    // this.wmsAppUrlEtiquetas = AJUSTES_DEFAULT.WMS_APP_URL_ETIQUETAS;


    this.diasValidezToken = AJUSTES_DEFAULT.DIAS_VALIDEZ_TOKEN;
    this.apiKey = AJUSTES_DEFAULT.API_KEY;
    this.realm = AJUSTES_DEFAULT.REALM;

    this.blnPrintWifi = true;
    this.strIP = AJUSTES_DEFAULT.IP;
    this.intPuerto = AJUSTES_DEFAULT.PUERTO_IP;

    this.blnPrintBluetooth = false;
    this.strPortName = AJUSTES_DEFAULT.PORT_NAME_BT;
    this.intBaudRate = AJUSTES_DEFAULT.BAUD_RATE_BT;
    this.strBTImpresora = AJUSTES_DEFAULT.IMPRESORA_BT;

    this.blnEsHadHeld = EsHadHeld;

    this.blnZebraBrowserPrint = false;
    this.strUidZebraBrowserPrint = '';

    // Parámetros para obtener datos desde el lector de códigos de barras del dispositivo HandHeld
    if (EsHadHeld) {
      this.blnPuedeUsarTecladoEnEscaneo = false;
    } else {
      this.blnPuedeUsarTecladoEnEscaneo = true;
    }

    this.strBroadcastScanerDataIntent = AJUSTES_DEFAULT.BROADCAST_SCANER_DATA_INTENT;
    this.strBroadcastScanerDataId = AJUSTES_DEFAULT.BROADCAST_SCANER_DATA_ID;

    // this.strAdminPass = AJUSTES_DEFAULT.ADMIN_PASS;

    this.strTemaSonidos = AJUSTES_DEFAULT.TEMA_SONIDOS;
    this.strMensajeError = AJUSTES_DEFAULT.MENSAJE_ERROR;
    this.strMensajeCorrecto = AJUSTES_DEFAULT.MENSAJE_CORRECTO;
    this.strMensajeErrorConeccion = AJUSTES_DEFAULT.MENSAJE_ERROR_CONECCION;
    this.strMensajeCorrectoConeccion = AJUSTES_DEFAULT.MENSAJE_CORRECTO_CONECCION;
    this.strMensajeCompletado = AJUSTES_DEFAULT.MENSAJE_COMPLETADO;
    this.strMensajeAtencion = AJUSTES_DEFAULT.MENSAJE_ATENCION;

    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)');
    this.blnDarkMode = prefersDark.matches;
  }
}



export enum TipoSonidoEvento {
  MensajeError = 'MensajeError',
  MensajeCorrecto = 'MensajeCorrecto',
  MensajeErrorConeccion = 'MensajeErrorConeccion',
  MensajeCorrectoConeccion = 'MensajeCorrectoConeccion',
  MensajeCompletado = 'MensajeCompletado',
  MensajeAtencion = 'MensajeAtencion'
}

export enum ModulosSistema {
  IdModuloWMSArribos = 1,
  IdModuloWMSEntradas = 2,
  IdModuloWMSSalidas = 3,
  IdModuloWMSMaestroProductos = 4,
  IdModuloWMSPerfiles = 6,
  IdModuloWMSSAjustes = 14,
  IdModuloWMSSAuditoria = 16,
  IdModuloWMSSReporteSalidas = 17,

  IdModuloControlLlegadas = 9,

  IdModuloWMSTareasPendiente = 10,
  IdModuloMovimientosinventario = 11,

  IdModuloWMSReporteCierreMensual = 19,
  IdModuloWMSAdministracion = 12,

  IdModuloWMSRacksMoviles = 20,
  IdModuloWMSMovimientosRacksMoviles = 27,
  IdModuloCatalogos = 24,

  IdModuloWMSSAuditoriaInventario = 25,

  IdModuloWMSRacksMovimientos = 27,

  IdModuloWMSSalidasBtm = 31,

  IdReporteRotacionInventario = 33,
  IdReporteOcupacionEnTarimasTabsPage = 34,
  IdModuloAdministraciónUsuarios = 35,
  IdModuloReportedeInventario = 36,
  IdModuloWMSReabasto = 37,
  IdModuloAdministraciónClientes = 39,
  IdModuloWMSPivoteDeSalidas = 41,
  IdModuloSalidaDevoluciones = 43,
  IdModuloBitacoraPlantillas = 44,
  IdModuloTareasProgramadas = 45,
  IdModuloPresurtido = 46,
  IdModuloIndicadoresKpi = 47,
  IdModuloWMSSalidaDatosComplementarios = 49,
  IdModuloWMSReporteSalidasPaqueteria = 50,
  IdModuloWMSNotificaciones = 51,
  IdModuloWMSTareasPendientesAgrupadas = 54,
  IdModuloWMSMaestroProductosComplementarios = 55,
  IDUbicacionProductos=56,
  IdModuloWMSHistorialMercanciaPage = 57,
  IdInventarioPorUbicacion = 58,
  IdMovimientosPorSKU = 59,
  IdInventarioPorProducto = 61,
  IdModuloWMSAyuda = 62,
  IdModuloWMSEstatusSalidas = 63,
}

export enum TiposDocumentos {

  IdTipoDocumumentoReporteResumenEntrada = 6,
  IdTipoDocumumentoReporteIdentificacionTarimas = 7,
  IdTipoDocumumentoReporteNotificacionSurtido = 8,
  IdTipoDocumentoReportePrimerConteo = 9,
  IdTipoDocumentoReporteSegundoConteo = 10,
  IdTipoDocumentoReporteTercerConteo = 11,
  IdTipoDocumentoReporteCuartoConteo = 12,
  IdTipoDocumentoReporteResumenSalida = 13,
  IdTipoDocumentoFotografia = 14,
  IdTipoDocumentoFirmaDigitalSeguridadAlmacen = 15,
  IdTipoDocumentoFirmaDigitalRecibeTransporte = 16,
  IdTipoDocumentoFirmaDigitalEntregaAlmacen = 17,
  IdFotosRackMoviles = 18,
  IdFotografiasMovimientosRackMoviles = 22,
  IdFotografíasControlLlegada = 23,
  IdTipoDocumumentoReporteResumenArribo = 24,
  IdTipoDocumentoFirmaDigitalResponsableEntrega = 25,
  IdTipoDocumentoFirmaDigitalResponsableRecibo = 26,
  IdTipoDocumentoFotografiaEvidenciaEntrega = 27,
  IdTipoDocumumentoReporteNotificacionPresurtido = 50,
  IdTipoDocumentoReporteResumenPresurtido = 51

}

export enum NivelAuditoria {
  IdNivelAuditoriaCaja = 1,
  IdNivelAuditoriaPieza = 2
}

export enum NumeroConteoAuditoria {
  IdPrimerConteo = 1,
  IdSegundoConteo = 2,
  IdTercerConteo = 3
}

export enum TipoRangoFechas {
  Mes = 'Mes',
  Dia = 'Dia',
  Anio = 'Anio'
}

export enum Etiquetas {
  IdEtiquetaEntrada = 1
}

export enum AccionesImprimirEtiqueta {
  IdImprimirTodasEtiquetas = 1,
  IdImprimirConsecutivos = 2,
  IdImprimirBultos = 3,
  IdImprimirRangoConsecutivos = 4,
  IdImprimirTodasEtiquetasSalida = 5,
  IdImprimirPT = 6,
  IdImprimirConsecutivoCaja = 7,
  IdImprimirUCC = 8,
  IdImprimirRangoConsecutivoCaja = 9,
  IdImprimirEtiquetaDanio = 10,
  IdImprimirEtiquetaPreLPN = 11
}

export enum CatalogosSistema {
  IdCatalogoWMSUbicacionesMoviles = 32
}

// ^pasK4L630,




export enum ConstantesGalo {
  ModuloArribos = 255,
  ModuloEntradas = 225
}

export interface Printer {
  printer: BrowserPrinters[];
}

export interface BrowserPrinters {
  name: string;
  uid: string;
  connection: string;
  deviceType?: string;
  version?: number;
  provider?: string;
  manufacturer?: string;
  readRetries?: number;
  send?(dataToWrite: any, data: any, errorCallback: (errorMessage: any) => void);
  read?(readCallback: (readData: any) => void, errorCallback: (errorMessage: any) => void);
  convertAndSendFile?(url: string, data: any, errorCallback: (errorMessage: any) => void);
  sendFile?(url: string, data: any, errorCallback: (errorMessage: any) => void);
  getStatus?(arg0: string, arg1: (text: any) => void, errorCallback: (errorMessage: any) => void);
}
